import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#26A69A',
        primary_2: '#536DFE',
        grey_1: '#EEEEEE',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF0000',
        info: '#2196F3',
        success: '#004D40',
        warning: '#FFFF00',
        success2: '#4caf50',
        error2: '#ff5252'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
